import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [role, setRole] = useState('admin');
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });

  const handleLogin = (e) => {
    e.preventDefault();
    localStorage.setItem('userRole', role);
    
    if (role === 'admin') {
      navigate('/dashboard');
    } else if (role === 'employee') {
      navigate('/employee-dashboard');
    } else {
      navigate('/jobs');
    }
  };

  return (
    <motion.div 
      initial={{ opacity: 0, x: 20 }} 
      animate={{ opacity: 1, x: 0 }} 
      transition={{ duration: 0.5 }} 
      className="w-full max-w-[380px] mx-auto"
    >
      <div className="text-left mb-8">
        <h5 className="text-[#11469A] text-xl font-bold mb-2">Welcome Back!</h5>
        <p className="text-[#878a99] text-sm">Sign in to continue to RM Ghana Portal.</p>
      </div>

      <div className="flex bg-gray-100 p-1 rounded-lg mb-8 shadow-inner">
        <button 
          onClick={() => setRole('admin')}
          className={`flex-1 py-2 text-[11px] font-bold uppercase tracking-wider rounded-md transition-all ${role === 'admin' ? 'bg-white text-[#11469A] shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
        >
          Admin
        </button>
        <button 
          onClick={() => setRole('employee')}
          className={`flex-1 py-2 text-[11px] font-bold uppercase tracking-wider rounded-md transition-all ${role === 'employee' ? 'bg-white text-[#11469A] shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
        >
          Employee
        </button>
        <button 
          onClick={() => setRole('candidate')}
          className={`flex-1 py-2 text-[11px] font-bold uppercase tracking-wider rounded-md transition-all ${role === 'candidate' ? 'bg-white text-[#11469A] shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
        >
          Candidate
        </button>
      </div>

      <form onSubmit={handleLogin} className="space-y-5">
        <div>
          <label className="block text-[12px] font-bold text-gray-500 uppercase tracking-wider mb-2">Email Address</label>
          <input 
            type="email" 
            placeholder="Enter your email" 
            className="w-full px-4 py-3 rounded border border-[#ced4da] focus:border-[#00AEEF] focus:ring-2 focus:ring-[#00AEEF]/20 outline-none transition-all placeholder:text-[#adb5bd] text-[13px]" 
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            required 
          />
        </div>

        <div>
          <div className="flex justify-between items-center mb-2">
            <label className="block text-[12px] font-bold text-gray-500 uppercase tracking-wider">Password</label>
            <a href="#" className="text-[12px] font-semibold text-[#878a99] hover:text-[#00AEEF] transition-colors">Forgot password?</a>
          </div>
          <div className="relative">
            <input 
              type={showPassword ? "text" : "password"} 
              placeholder="Enter password" 
              className="w-full px-4 py-3 rounded border border-[#ced4da] focus:border-[#00AEEF] focus:ring-2 focus:ring-[#00AEEF]/20 outline-none transition-all placeholder:text-[#adb5bd] text-[13px] pr-10" 
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required 
            />
            <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center text-[#878a99] hover:text-[#495057]">
              <SafeIcon name={showPassword ? "EyeOff" : "Eye"} size={16} />
            </button>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <input 
            type="checkbox" 
            id="rememberMe"
            className="h-4 w-4 rounded border-gray-300 text-[#00AEEF] focus:ring-[#00AEEF]"
            checked={formData.rememberMe}
            onChange={(e) => setFormData({ ...formData, rememberMe: e.target.checked })}
          />
          <label htmlFor="rememberMe" className="text-[13px] text-gray-500 font-medium cursor-pointer">Remember me</label>
        </div>

        <button 
          type="submit" 
          className="w-full bg-[#11469A] hover:bg-[#0d3678] text-white py-3.5 rounded font-bold transition-all shadow-md mt-6 text-[13px] uppercase tracking-wider"
        >
          Sign In
        </button>
      </form>

      <div className="mt-10 text-center sm:text-left">
        <p className="text-[13px] text-[#878a99]">
          Don't have an account?{' '}
          <Link to="/signup" className="text-[#00AEEF] font-bold hover:underline decoration-2 underline-offset-4">
            Sign Up
          </Link>
        </p>
      </div>
    </motion.div>
  );
};

export default Login;